import { SGeneralForms } from 'shj-components'
import { useEffect, useRef } from 'react'
import { message } from 'antd'
import { isEmpty } from 'lodash-es'
import dayjs from 'dayjs'
import { getSpaceSpecificationArgList, priceLimitImportFeesUpdateById } from '@/services/product.ts'

const AddOrEditConfigure = props => {
  const { editRef, priceItemId } = props
  const ref = useRef()

  const onFormRef = () => {
    const { onFormRef } = ref.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    if (!isEmpty(props.record)) {
      console.log(props.record, 'props.record');
      
      const obj = {
        ...props.record,
        startDate: dayjs(props?.record?.startDate),
        endDate: props?.record?.endDate && dayjs(props?.record?.endDate),
      }
      onFormRef()?.setFieldsValue(obj)
    }
    return () => {
      onFormRef()?.resetFields()
    }
  }, [props.record])

  const onFinish = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        props.setLoading?.(true)
        const values_ = {
          ...values,
          startDate: values.startDate && dayjs(values.startDate).format('YYYY-MM-DD'),
          endDate: values.endDate && dayjs(values.endDate).format('YYYY-MM-DD'),
          priceItemId,
        }
        priceLimitImportFeesUpdateById({ data: values_ })
          .then(res => {
            message.success(res.message || '操作成功')
            props.fn?.()
            props.onClose?.()
          })
          .finally(() => props.setLoading?.(false))
      })
  }

  if (editRef.current) editRef.current.onFinish = onFinish
  const httpOptionsFn = () => {
    console.log(props, '11111111')
    return new Promise(async resolve => {
      const spaceArgList: any = await getSpaceSpecificationArgList(props?.record?.spaceArgId)
      resolve({
        spaceArgList: spaceArgList.map(item => {
          return {
            label: item.argValue,
            value: item.id,
          }
        }),
      })
    })
  }
  return (
    <>
      <SGeneralForms
        ref={ref}
        layout={'vertical'}
        httpOptionsFn={httpOptionsFn}
        configs={[
          {
            formItem: [
              { name: 'id', hidden: true },
              {
                label: '参数值',
                spanCol: 24,
                name: 'spaceArgValueId',
                required: true,
                rules: [{ required: true, message: '参数值不能为空' }],
                type: 'select',
                data: 'spaceArgList',
              },
              {
                label: '金额 (元)',
                spanCol: 24,
                name: 'price',
                required: true,
                rules: [{ required: true, message: '金额不能为空' }],
                type: 'inputNumber',
                comConfig: {
                  min: 0,
                  precision: 2,
                },
              },
              {
                spanCol: 24,
                label: '开始日期',
                name: 'startDate',
                required: true,
                rules: [{ required: true, message: '开始日期不能为空' }],
                type: 'date',
              },
              {
                spanCol: 24,
                label: '结束日期',
                name: 'endDate',
                type: 'date',
                comConfig: {
                  disabledDate: current => {
                    const startDate = onFormRef()?.getFieldValue('startDate')
                    if (startDate) return current && current < dayjs(startDate).endOf('day')
                  },
                },
              },
            ],
          },
        ]}
      />
    </>
  )
}

export default AddOrEditConfigure
